import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CommentItem from './CommentItem';
import _isNumber from 'lodash/isNumber';

export class CommentList extends PureComponent {
  static propTypes = {
    comments: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onViewSingleComment: PropTypes.func,
    maxNumberOfComments: PropTypes.number
  };

  render() {
    const {
      comments,
      users,
      onDelete,
      onEditClick,
      onViewSingleComment,
      maxNumberOfComments = null
    } = this.props;

    const commentsToDisplay = _isNumber(maxNumberOfComments)
      ? comments.slice(0, maxNumberOfComments)
      : comments;

    return (
      <div>
        {commentsToDisplay.map((comment, index) => {
          return (
            <CommentItem
              key={index}
              comment={comment}
              users={users}
              onDelete={onDelete}
              onEditClick={onEditClick}
              onViewSingleComment={onViewSingleComment || null}
            />
          );
        })}
      </div>
    );
  }
}
export default CommentList;
